// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__ANdA0","LoaderIcon":"Loader_LoaderIcon__3JaoH","spin":"Loader_spin__3pTHl"};